<template>
  <div class="chat-message-item">
    <div class="message-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TEXT">{{ msgInfo.content }}</div>
    <div class="message-tip" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">{{ $date.toTimeText(msgInfo.sendTime) }}</div>
    <div class="message-normal" v-else-if="isNormal" :class="{ 'message-mine': mine, 'message-selecting': selectionMode, 'message-private': isPrivateChat }"
      @click="onMessageClick">
      <div v-if="selectionMode && canSelect" class="message-select-toggle" :class="{ checked: selected }"
        @click.stop="onToggleSelect">
      </div>
      <div class="head-image" @click.stop="showMessageUserInfo">
        <head-image
          :name="originalName || showName"
          :size="38"
          :url="headImage"
          :id="avatarUserId"
          :isShowUserInfo="false">
        </head-image>
      </div>
      <div class="content">
        <div v-show="showSenderName && mode == 1" class="message-top">
          <span>{{ showName }}</span>
        </div>
        <div v-show="showSenderName && mode == 2" class="message-top">
          <span>{{ showName }}</span>
          <span>{{ $date.toTimeText(msgInfo.sendTime) }}</span>
        </div>
		<div class="message-bottom" @contextmenu.prevent="showRightMenu($event)">
			<div ref="chatMsgBox">
			<span v-if="showLocalSendLoading" title="正在重试" class="local-send-state local-send-loading el-icon-loading"></span>
			<span v-else-if="showLocalSendFail" title="发送失败，点击重试" class="local-send-state local-send-fail el-icon-warning" @click.stop="onRetrySend"></span>
			<span class="message-text" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TEXT" v-html="htmlText"></span>
            <div class="message-image" v-if="msgInfo.type == $enums.MESSAGE_TYPE.IMAGE">
              <div class="img-load-box" v-loading="loading" element-loading-text="上传中.." element-loading-background="rgba(0, 0, 0, 0.4)">
                <img class="send-image" :src="JSON.parse(msgInfo.content).thumbUrl" @click="showFullImageBox()" loading="lazy" />
              </div>
              <span title="发送失败" v-show="loadFail" @click="onSendFail" class="send-fail el-icon-warning"></span>
            </div>
            <div class="message-file" v-if="msgInfo.type == $enums.MESSAGE_TYPE.FILE">
              <div class="chat-file-box" v-loading="loading" @click.stop="openFile">
                <div class="chat-file-info">
                  <span class="chat-file-name">{{ data.name }}</span>
                  <div class="chat-file-size">{{ fileSize }}</div>
                </div>
                <div class="chat-file-icon" :class="fileIconMeta.className">
                  <div class="file-icon-paper">
                    <div class="file-icon-fold"></div>
                    <span class="file-icon-mark">{{ fileIconMeta.mark }}</span>
                  </div>
                </div>
              </div>
              <span title="发送失败" v-show="loadFail" @click="onSendFail" class="send-fail el-icon-warning"></span>
            </div>
            <div class="message-location" v-if="msgInfo.type == $enums.MESSAGE_TYPE.LOCATION && locationData"
              @click.stop="openLocationMap">
              <div class="location-map-preview">
                <img v-if="locationMapUrl && !locationMapLoadFailed" class="location-map-image"
                  :src="locationMapUrl" :alt="locationData.name" @error="onLocationMapError" />
                <div v-else class="location-map-placeholder">
                  <i class="el-icon-location"></i>
                  <span>地图缩略图暂时无法加载</span>
                </div>
              </div>
              <div class="location-info">
                <div class="location-name">{{ locationData.name }}</div>
                <div class="location-address">{{ locationData.address }}</div>
              </div>
            </div>
            <!-- 名片消息 -->
            <div class="message-card" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.FRIEND_CARD && friendCardData"
              @click="onOpenFriendCard($event)">
              <div class="card-main">
                <head-image
                  class="card-avatar"
                  :name="friendCardData.nickName"
                  :url="friendCardAvatarForDisplay"
                  :size="42"
                  radius="10px"
                  :isShowUserInfo="false"
                ></head-image>
                <div class="card-name">{{ friendCardData.nickName }}</div>
              </div>
              <div class="card-divider"></div>
              <div class="card-tip">个人名片</div>
            </div>
            <div class="message-merged-forward" v-if="msgInfo.type == $enums.MESSAGE_TYPE.MERGED_FORWARD && mergedForwardData"
              @click.stop="openMergedForwardDetail">
              <div class="merged-forward-title">{{ mergedForwardData.title }}</div>
              <div class="merged-forward-lines">
                <div class="merged-forward-line" v-for="(line, index) in mergedForwardSummaryLines" :key="index">
                  {{ line }}
                </div>
              </div>
              <div class="merged-forward-divider"></div>
              <div class="merged-forward-tip">聊天记录</div>
            </div>
          </div>
          <div v-if="msgInfo.quoteMessage" class="message-quote">
            <div class="quote-content" :class="{
              'quote-content-rich': isRichQuote(msgInfo.quoteMessage),
              'quote-content-stacked': isQuoteStackedPlain(msgInfo.quoteMessage)
            }">
              <template v-if="isRichQuote(msgInfo.quoteMessage)">
                <template v-if="isQuoteImage(msgInfo.quoteMessage)">
                  <span class="quote-heading">
                    <span class="quote-name">{{ msgInfo.quoteMessage.sendNickName || showName }}：</span>
                  </span>
                  <img v-if="isQuoteImage(msgInfo.quoteMessage)" class="quote-rich-thumb" :src="getQuoteImageSrc(msgInfo.quoteMessage)" alt="图片" />
                </template>
                <template v-else-if="isQuoteFriendCard(msgInfo.quoteMessage)">
                  <span class="quote-heading">
                    <span class="quote-name">{{ msgInfo.quoteMessage.sendNickName || showName }}：</span>
                    <span class="quote-type-label">{{ getQuoteTypeLabel(msgInfo.quoteMessage) }}</span>
                  </span>
                  <div class="quote-card-brief">
                    <i class="quote-card-type-icon el-icon-user"></i>
                    <span class="quote-card-name">{{ getQuoteFriendCardName(msgInfo.quoteMessage) }}</span>
                  </div>
				  <head-image class="quote-rich-thumb" :name="getQuoteFriendCardName(msgInfo.quoteMessage)"
					:url="getQuoteFriendCardAvatar(msgInfo.quoteMessage)" :size="42" radius="4px"
					:isShowUserInfo="false"></head-image>
                </template>
                <div v-else class="quote-rich-main">
                  <div v-if="isQuoteFile(msgInfo.quoteMessage)" class="quote-flow-copy">
                    <span class="quote-flow-prefix">
                      <span class="quote-name">{{ msgInfo.quoteMessage.sendNickName || showName }}：</span>
                      <span class="quote-type-label">{{ getQuoteTypeLabel(msgInfo.quoteMessage) }}</span>
                    </span>
                    <span class="quote-flow-body">　　{{ getRichQuoteText(msgInfo.quoteMessage) }}</span>
                  </div>
                  <div v-else class="quote-rich-line">
                    <span class="quote-heading">
                      <span class="quote-name">{{ msgInfo.quoteMessage.sendNickName || showName }}：</span>
                      <span class="quote-type-label">{{ getQuoteTypeLabel(msgInfo.quoteMessage) }}</span>
                    </span>
                    <i class="quote-rich-icon el-icon-document"></i>
                    <span class="quote-rich-text">{{ getRichQuoteText(msgInfo.quoteMessage) }}</span>
                  </div>
                </div>
                <div v-if="isQuoteFile(msgInfo.quoteMessage)" class="quote-rich-thumb quote-file-placeholder">
                  <span class="quote-file-icon" :class="getQuoteFileIconMeta(msgInfo.quoteMessage).className">
                    <span class="file-icon-paper">
                      <span class="file-icon-fold"></span>
                      <span class="file-icon-mark">{{ getQuoteFileIconMeta(msgInfo.quoteMessage).mark }}</span>
                    </span>
                  </span>
                </div>
              </template>
              <template v-else>
                <div class="quote-flow-copy">
                  <span class="quote-flow-prefix">
                    <span class="quote-name">{{ msgInfo.quoteMessage.sendNickName || showName }}：</span>
                    <span v-if="getQuoteTypeLabel(msgInfo.quoteMessage)" class="quote-type-label">{{ getQuoteTypeLabel(msgInfo.quoteMessage) }}</span>
                  </span>
                  <span v-if="getQuoteBodyText(msgInfo.quoteMessage)" class="quote-flow-body">　　{{ getQuoteBodyText(msgInfo.quoteMessage) }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="message-voice" v-if="msgInfo.type == $enums.MESSAGE_TYPE.AUDIO" @contextmenu.prevent="showRightMenu($event)">
          <div class="voice-player">
            <audio ref="voiceAudio" controls :src="JSON.parse(msgInfo.content).url" @play="onPlayVoice"
              @pause="onStopVoice" @ended="onStopVoice" @volumechange="syncVoiceVolume" @contextmenu.prevent></audio>
            <div ref="voiceVolumeControl" class="voice-volume-control" @click.stop>
              <button class="voice-volume-button" type="button" title="调节音量" aria-label="调节音量"
                aria-haspopup="true" :aria-expanded="String(volumePanelVisible)" @click.stop="toggleVoiceVolumePanel">
                <svg class="voice-volume-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path class="voice-volume-speaker" d="M4 9v6h4l5 4V5L8 9H4z"></path>
                  <path v-if="voiceVolume > 0" class="voice-volume-wave" d="M16 9.2a4 4 0 0 1 0 5.6"></path>
                  <path v-if="voiceVolume > 0.45" class="voice-volume-wave" d="M18.7 6.7a7.5 7.5 0 0 1 0 10.6"></path>
                  <path v-if="voiceVolume === 0" class="voice-volume-wave" d="M16.5 9.5l5 5m0-5l-5 5"></path>
                </svg>
              </button>
              <div v-show="volumePanelVisible" class="voice-volume-panel">
                <input v-model.number="voiceVolume" class="voice-volume-slider" type="range" min="0" max="1"
                  step="0.05" orient="vertical" aria-label="语音消息音量" @input="onVoiceVolumeChange" />
              </div>
            </div>
          </div>
          <div v-if="speechTextMap[msgInfo.id] && speechTextMap[msgInfo.id].trim()" class="speech-text-result">{{ speechTextMap[msgInfo.id] }}</div>
        </div>
        <div class="chat-action message-text" v-if="isAction">
          <span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VOICE" title="重新呼叫" @click="$emit('call')" class="el-icon-phone-outline chat-icon"></span>
          <span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VIDEO" title="重新呼叫" @click="$emit('call')" class="el-icon-video-camera chat-icon"></span>
          <span>{{ actionText }}</span>
        </div>
        <div class="message-status" v-if="showPrivateStatus">
          <span
            v-if="msgInfo.status === $enums.MESSAGE_STATUS.READED"
            class="chat-readed"
          >已读</span>
          <span
            v-else
            class="chat-unread"
          >未读</span>
        </div>
        <div class="chat-receipt" v-if="showGroupReceipt" @click="onShowReadedBox" style="display:inline-flex;margin-top:4px;font-size:12px;line-height:16px;cursor:pointer;">
          <span v-if="groupUnreadCount > 0" style="font-size:12px;color:var(--im-color-danger);font-weight:500;">{{ groupUnreadCount }}人未读</span>
          <span v-else style="font-size:12px;color:var(--im-text-color-light);">全部已读</span>
        </div>
      </div>
    </div>
    <div v-if="showMergedForwardDetail" class="merged-forward-detail-mask" @click="closeMergedForwardDetail">
      <div class="merged-forward-detail-panel" @click.stop>
        <div class="merged-forward-detail-header">
          <span class="merged-forward-detail-title">{{ currentMergedForwardData && currentMergedForwardData.title }}</span>
          <i class="merged-forward-detail-close el-icon-close" @click="closeMergedForwardDetail"></i>
        </div>
        <div class="merged-forward-detail-body">
          <div v-for="(record, index) in mergedForwardRecords" :key="index" class="merged-forward-record">
            <div class="merged-forward-record-meta">
              <span class="merged-forward-record-name">{{ record.sendNickName || '未知用户' }}</span>
              <span v-if="record.sendTime" class="merged-forward-record-time">{{ formatMergedForwardRecordTime(record.sendTime) }}</span>
            </div>
            <img
              v-if="isMergedForwardImage(record)"
              class="merged-forward-record-image"
              :src="getMergedForwardImageSrc(record)"
              @click.stop="previewMergedForwardImage(record)"
            />
            <div v-else-if="isMergedForwardFile(record)" class="merged-forward-record-file"
              @click.stop="openMergedForwardFile(record)">
              <div class="merged-forward-record-file-info">
                <div class="merged-forward-record-file-name">{{ getMergedForwardFileName(record) }}</div>
                <div class="merged-forward-record-file-size">{{ getMergedForwardFileSize(record) }} 未下载</div>
              </div>
              <div class="merged-forward-record-file-icon" :class="getMergedForwardFileIconMeta(record).className">
                <div class="file-icon-paper">
                  <div class="file-icon-fold"></div>
                  <span class="file-icon-mark">{{ getMergedForwardFileIconMeta(record).mark }}</span>
                </div>
              </div>
            </div>
            <div v-else-if="isMergedForwardRecord(record)" class="merged-forward-record-card" @click="openNestedMergedForwardDetail(record)">
              <div class="merged-forward-record-card-title">{{ getNestedMergedForwardData(record).title }}</div>
              <div class="merged-forward-record-card-lines">
                <div v-for="(line, lineIndex) in getNestedMergedForwardData(record).summaryLines.slice(0, 3)" :key="lineIndex" class="merged-forward-record-card-line">
                  {{ line }}
                </div>
              </div>
              <div class="merged-forward-record-card-divider"></div>
              <div class="merged-forward-record-card-tip">聊天记录</div>
            </div>
            <div v-else class="merged-forward-record-bubble" v-html="getMergedForwardRecordHtml(record)"></div>
          </div>
        </div>
      </div>
    </div>
    <right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
    <chat-group-readed ref="chatGroupReadedBox" :msgInfo="msgInfo" :groupMembers="groupMembers"></chat-group-readed>
  </div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import RightMenu from '../common/RightMenu.vue';
import ChatGroupReaded from './ChatGroupReaded.vue';
import friendStore from "../../store/friendStore";
import { getFileExtensionFromContent, getFileIconMetaFromContent } from "../../utils/fileIcon";
// File icon groups are implemented in utils/fileIcon.js: mp3 wav flac m4a, mp4 avi mov mkv, doc docx xls xlsx ppt pptx.
export default {
	name: "messageItem",
	components: {
		HeadImage,
		RightMenu,
		ChatGroupReaded
	},
	props: {
		mode: {
			type: Number,
			default: 1
		},
		mine: {
			type: Boolean,
			required: true
		},
		headImage: {
			type: String,
			required: true
		},
		showName: {
			type: String,
			required: true
		},
		originalName: {
			type: String,
			default: null
		},
		chatType: {
			type: String,
			default: ''
		},
		userId: {
			type: [Number, String],
			default: null
		},
		msgInfo: {
			type: Object,
			required: true
		},
		groupMembers: {
			type: Array
		},
		menu: {
			type: Boolean,
			default: true
		},
		selectionMode: {
			type: Boolean,
			default: false
		},
		selected: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			audioPlayState: 'STOP',
			voiceVolume: 1,
			volumePanelVisible: false,
			speechTextMap: {}, // { [msgId]: "转写内容" }
			locationMapLoadFailed: false,
			showMergedForwardDetail: false,
			mergedForwardDetailStack: [],
			friendStore: friendStore()
		}
	},
	mounted() {
		// 进入页面时，批量读取所有消息的转写结果
		if (this.msgInfo && this.msgInfo.type === this.$enums.MESSAGE_TYPE.AUDIO) {
			document.addEventListener('pointerdown', this.onVoiceVolumeOutsidePointerDown);
			const msgId = this.msgInfo.id;
			const text = localStorage.getItem('speechText_' + msgId);
			if (text) {
				this.$set(this.speechTextMap, msgId, text);
			}
		}
	},
	methods: {
		parseQuoteContent(quoteMessage) {
			if (!quoteMessage || !quoteMessage.content) {
				return {};
			}
			if (typeof quoteMessage.content === 'object') {
				return quoteMessage.content;
			}
			try {
				return JSON.parse(quoteMessage.content);
			} catch (e) {
				return {};
			}
		},
		getQuoteImageSrc(quoteMessage) {
			if (!quoteMessage || quoteMessage.type != this.$enums.MESSAGE_TYPE.IMAGE) {
				return '';
			}
			const data = this.parseQuoteContent(quoteMessage);
			return data.thumbUrl || data.originUrl || data.url || '';
		},
		isQuoteImage(quoteMessage) {
			return quoteMessage && quoteMessage.type == this.$enums.MESSAGE_TYPE.IMAGE && !!this.getQuoteImageSrc(quoteMessage);
		},
		isQuoteFile(quoteMessage) {
			return quoteMessage && (quoteMessage.type == this.$enums.MESSAGE_TYPE.FILE
				|| quoteMessage.type == this.$enums.MESSAGE_TYPE.VIDEO);
		},
		isQuoteLocation(quoteMessage) {
			return quoteMessage && quoteMessage.type == this.$enums.MESSAGE_TYPE.LOCATION;
		},
		getQuoteLocationText(quoteMessage) {
			const data = this.parseQuoteContent(quoteMessage);
			return data.name || data.address || '位置';
		},
		isQuoteFriendCard(quoteMessage) {
			return quoteMessage && quoteMessage.type == this.$enums.MESSAGE_TYPE.FRIEND_CARD;
		},
		isQuoteMergedForward(quoteMessage) {
			return quoteMessage && quoteMessage.type == this.$enums.MESSAGE_TYPE.MERGED_FORWARD;
		},
		isQuoteStackedPlain(quoteMessage) {
			return !!(quoteMessage && quoteMessage.quoteMessage && !this.isRichQuote(quoteMessage))
				|| this.isQuoteLocation(quoteMessage)
				|| this.isQuoteMergedForward(quoteMessage);
		},
		getQuoteTypeLabel(quoteMessage) {
			if (!quoteMessage) return '';
			if (quoteMessage.quoteMessage) return '[引用]';
			const labels = {
				[this.$enums.MESSAGE_TYPE.FILE]: '[文件]',
				[this.$enums.MESSAGE_TYPE.AUDIO]: '[语音]',
				[this.$enums.MESSAGE_TYPE.VIDEO]: '[文件]',
				[this.$enums.MESSAGE_TYPE.LOCATION]: '[位置]',
				[this.$enums.MESSAGE_TYPE.FRIEND_CARD]: '[名片]',
				[this.$enums.MESSAGE_TYPE.MERGED_FORWARD]: '[引用]'
			};
			return labels[quoteMessage.type] || '';
		},
		getQuoteBodyText(quoteMessage) {
			if (!quoteMessage) return '';
			if (this.isQuoteMergedForward(quoteMessage)) {
				return this.getQuoteMergedForwardTitle(quoteMessage);
			}
			if (this.isQuoteLocation(quoteMessage)) {
				return this.getQuoteLocationText(quoteMessage);
			}
			if (quoteMessage.type == this.$enums.MESSAGE_TYPE.IMAGE
				|| quoteMessage.type == this.$enums.MESSAGE_TYPE.AUDIO
				|| quoteMessage.type == this.$enums.MESSAGE_TYPE.VIDEO) {
				return '';
			}
			return this.getQuoteDisplayText(quoteMessage);
		},
		getQuoteMergedForwardTitle(quoteMessage) {
			const data = this.parseQuoteContent(quoteMessage);
			return data.title || quoteMessage.title || '聊天记录';
		},
		getQuoteMergedForwardText(quoteMessage) {
			return `[引用]${this.getQuoteMergedForwardTitle(quoteMessage)}`;
		},
		getQuoteFileIconMeta(quoteMessage) {
			return getFileIconMetaFromContent(quoteMessage && quoteMessage.content);
		},
		isRichQuote(quoteMessage) {
			return this.isQuoteImage(quoteMessage) || this.isQuoteFile(quoteMessage) || this.isQuoteFriendCard(quoteMessage);
		},
		getQuoteFriendCard(quoteMessage) {
			const data = this.parseQuoteContent(quoteMessage);
			return data.card || data.friend || data.user || data;
		},
		getQuoteFriendCardAvatar(quoteMessage) {
			const data = this.getQuoteFriendCard(quoteMessage);
			return data.headImageThumb || data.headImage || data.avatar || data.portrait || data.url || '';
		},
		getQuoteFriendCardName(quoteMessage) {
			const data = this.getQuoteFriendCard(quoteMessage);
			return data.nickName || data.showNickName || data.name || data.userName || data.username || '个人名片';
		},
		getRichQuoteText(quoteMessage) {
			if (this.isQuoteImage(quoteMessage)) {
				return '[图片]';
			}
			if (this.isQuoteFriendCard(quoteMessage)) {
				return this.getQuoteFriendCardName(quoteMessage);
			}
			if (this.isQuoteFile(quoteMessage)) {
				const data = this.parseQuoteContent(quoteMessage);
				return data.name || '文件';
			}
			return this.getQuoteDisplayText(quoteMessage);
		},
		getQuoteDisplayText(quoteMessage) {
			if (!quoteMessage) return '';
			if (quoteMessage.type == this.$enums.MESSAGE_TYPE.TEXT) {
				let text = quoteMessage.content || '';
				text = text.replace(/<[^>]+>/g, '');
				text = text.replace(/#[^;]+;/g, '');
				text = text.replace(/【回执消息】/g, '');
				if (text.length > 50) {
					text = text.substring(0, 50) + '...';
				}
				return text || '[文本]';
			} else if (quoteMessage.type == this.$enums.MESSAGE_TYPE.IMAGE) {
				return '[图片]';
			} else if (quoteMessage.type == this.$enums.MESSAGE_TYPE.FILE) {
				try {
					const data = JSON.parse(quoteMessage.content);
					return `[文件] ${data.name || '文件'}`;
				} catch (e) {
					return '[文件]';
				}
			} else if (quoteMessage.type == this.$enums.MESSAGE_TYPE.FRIEND_CARD) {
				return `[名片] ${this.getQuoteFriendCardName(quoteMessage)}`.trim();
			} else if (this.isQuoteMergedForward(quoteMessage)) {
				return this.getQuoteMergedForwardText(quoteMessage);
			} else if (quoteMessage.type == this.$enums.MESSAGE_TYPE.AUDIO) {
				return '[语音]';
			} else if (quoteMessage.type == this.$enums.MESSAGE_TYPE.VIDEO) {
				return '[文件]';
			} else if (quoteMessage.type == this.$enums.MESSAGE_TYPE.LOCATION) {
				return '[位置]';
			}
			return '[消息]';
		},
		onSendFail() {
			this.$message.error("该文件已发送失败，目前不支持自动重新发送，建议手动重新发送")
		},
		onRetrySend() {
			this.$emit('retry-send', this.msgInfo);
		},
		showFullImageBox() {
			let imageUrl = JSON.parse(this.msgInfo.content).originUrl;
			if (imageUrl) {
				this.$eventBus.$emit("openFullImage", imageUrl);
			}
		},
		showMessageUserInfo(event) {
			if (!this.avatarUserId) {
				return;
			}
			this.$http({
				url: `/user/find/${this.avatarUserId}`,
				method: 'get'
			}).then((user) => {
				const x = event && (event.clientX || event.x) || 0;
				const y = event && (event.clientY || event.y) || 0;
				let pos = {
					x: x + 30,
					y
				};
				this.$eventBus.$emit("openUserInfo", user, pos);
			})
		},
		onPlayVoice() {
			this.audioPlayState = 'RUNNING';
		},
		onStopVoice() {
			this.audioPlayState = 'STOP';
		},
		toggleVoiceVolumePanel() {
			this.volumePanelVisible = !this.volumePanelVisible;
		},
		onVoiceVolumeChange() {
			const audio = this.$refs.voiceAudio;
			if (!audio) {
				return;
			}
			const volume = Math.max(0, Math.min(1, Number(this.voiceVolume)));
			audio.volume = volume;
			audio.muted = volume === 0;
		},
		syncVoiceVolume(event) {
			const audio = event && event.target;
			if (audio) {
				this.voiceVolume = audio.muted ? 0 : audio.volume;
			}
		},
		onVoiceVolumeOutsidePointerDown(event) {
			const control = this.$refs.voiceVolumeControl;
			if (this.volumePanelVisible && control && !control.contains(event.target)) {
				this.volumePanelVisible = false;
			}
		},
		parseMediaContent() {
			if (!this.msgInfo || !this.msgInfo.content) {
				return {};
			}
			if (typeof this.msgInfo.content === 'object') {
				return this.msgInfo.content;
			}
			try {
				return JSON.parse(this.msgInfo.content);
			} catch (e) {
				return {};
			}
		},
		onLocationMapError() {
			this.locationMapLoadFailed = true;
		},
		openLocationMap() {
			const data = this.locationData;
			if (!data) {
				this.$message.warning('位置数据无效');
				return;
			}
			const params = new URLSearchParams({
				position: `${data.longitude},${data.latitude}`,
				name: data.name,
				src: process.env.VUE_APP_NAME || 'IMOA',
				coordinate: 'gaode',
				callnative: '0'
			});
			window.open(`https://uri.amap.com/marker?${params.toString()}`, '_blank', 'noopener,noreferrer');
		},
		getMediaUrl() {
			const data = this.parseMediaContent();
			if (this.msgInfo.type === this.$enums.MESSAGE_TYPE.IMAGE) {
				return data.originUrl || data.url || data.thumbUrl || '';
			}
			return data.url || '';
		},
		parseMergedForwardContent() {
			if (!this.msgInfo || !this.msgInfo.content) {
				return null;
			}
			if (typeof this.msgInfo.content === 'object') {
				return this.msgInfo.content;
			}
			try {
				return JSON.parse(this.msgInfo.content);
			} catch (e) {
				return null;
			}
		},
		openMergedForwardDetail() {
			this.showMergedForwardDetail = true;
			this.mergedForwardDetailStack = [];
			this.emitMergedForwardDetailVisible(true);
		},
		closeMergedForwardDetail() {
			if (this.mergedForwardDetailStack.length) {
				this.mergedForwardDetailStack.pop();
				return;
			}
			this.showMergedForwardDetail = false;
			this.emitMergedForwardDetailVisible(false);
		},
		emitMergedForwardDetailVisible(visible) {
			this.$eventBus.$emit('mergedForwardDetailVisible', !!visible);
		},
		padMergedForwardTimePart(value) {
			return String(value).padStart(2, '0');
		},
		formatMergedForwardRecordTime(sendTime) {
			const date = new Date(sendTime);
			if (Number.isNaN(date.getTime())) {
				return '';
			}
			const month = this.padMergedForwardTimePart(date.getMonth() + 1);
			const day = this.padMergedForwardTimePart(date.getDate());
			const hour = this.padMergedForwardTimePart(date.getHours());
			const minute = this.padMergedForwardTimePart(date.getMinutes());
			return `${date.getFullYear()}-${month}-${day} ${hour}:${minute}`;
		},
		parseMergedForwardRecordContent(record) {
			if (!record || !record.content) {
				return {};
			}
			if (typeof record.content === 'object') {
				return record.content;
			}
			try {
				return JSON.parse(record.content);
			} catch (e) {
				return {};
			}
		},
		getMergedForwardImageSrc(record) {
			if (!record || record.type != this.$enums.MESSAGE_TYPE.IMAGE) {
				return '';
			}
			const data = this.parseMergedForwardRecordContent(record);
			return data.originUrl || data.url || data.thumbUrl || '';
		},
		isMergedForwardImage(record) {
			return record && record.type == this.$enums.MESSAGE_TYPE.IMAGE && !!this.getMergedForwardImageSrc(record);
		},
		isMergedForwardFile(record) {
			return record && record.type == this.$enums.MESSAGE_TYPE.FILE;
		},
		getMergedForwardFileData(record) {
			return this.parseMergedForwardRecordContent(record);
		},
		getMergedForwardFileName(record) {
			const data = this.getMergedForwardFileData(record);
			return data.name || data.fileName || '文件';
		},
		getMergedForwardFileSize(record) {
			const data = this.getMergedForwardFileData(record);
			const size = Number(data.size || 0);
			if (!size) {
				return '';
			}
			if (size > 1024 * 1024) {
				return `${Math.round(size / 1024 / 1024 * 10) / 10}M`;
			}
			if (size > 1024) {
				return `${Math.round(size / 1024 * 10) / 10}K`;
			}
			return `${size}B`;
		},
		getMergedForwardFileIconMeta(record) {
			return getFileIconMetaFromContent(record && record.content);
		},
		openMergedForwardFile(record) {
			const data = this.getMergedForwardFileData(record);
			const url = data.url || data.originUrl || '';
			if (!url) {
				this.$message.error('文件地址无效');
				return;
			}
			window.open(url, '_blank', 'noopener,noreferrer');
		},
		getNestedMergedForwardData(record) {
			const data = this.parseMergedForwardRecordContent(record);
			return {
				title: data.title || '聊天记录',
				summaryLines: Array.isArray(data.summaryLines) ? data.summaryLines : [],
				records: Array.isArray(data.records) ? data.records : []
			};
		},
		isMergedForwardRecord(record) {
			return record && record.type == this.$enums.MESSAGE_TYPE.MERGED_FORWARD && this.getNestedMergedForwardData(record).records.length > 0;
		},
		openNestedMergedForwardDetail(record) {
			if (!this.isMergedForwardRecord(record)) {
				return;
			}
			this.mergedForwardDetailStack.push(this.getNestedMergedForwardData(record));
		},
		previewMergedForwardImage(record) {
			const imageUrl = this.getMergedForwardImageSrc(record);
			if (imageUrl) {
				this.$eventBus.$emit("openFullImage", imageUrl);
			}
		},
		getMergedForwardRecordText(record) {
			if (!record) return '[消息]';
			if (record.type == this.$enums.MESSAGE_TYPE.TEXT) {
				return record.content || '[文本]';
			}
			if (record.type == this.$enums.MESSAGE_TYPE.IMAGE) {
				return '[图片]';
			}
			if (record.type == this.$enums.MESSAGE_TYPE.FILE) {
				try {
					const data = typeof record.content === 'object' ? record.content : JSON.parse(record.content);
					return `[文件] ${data.name || '文件'}`;
				} catch (e) {
					return '[文件]';
				}
			}
			if (record.type == this.$enums.MESSAGE_TYPE.AUDIO) {
				return '[语音]';
			}
			if (record.type == this.$enums.MESSAGE_TYPE.VIDEO) {
				return '[文件]';
			}
			if (record.type == this.$enums.MESSAGE_TYPE.FRIEND_CARD) {
				return '[个人名片]';
			}
			return '[消息]';
		},
		getMergedForwardRecordHtml(record) {
			const text = record && record.text ? record.text : this.getMergedForwardRecordText(record);
			const linkedText = this.$url.replaceURLWithHTMLLinks(String(text || ''), '');
			return this.$emo.transform(linkedText, 'emoji-normal');
		},
		sanitizeDownloadName(name) {
			return String(name || 'download')
				.replace(/[\\/:*?"<>|]/g, '_')
				.trim() || 'download';
		},
		openFile() {
			const url = this.getMediaUrl();
			if (!url) {
				this.$message.error('文件地址无效');
				return;
			}
			window.open(url, '_blank', 'noopener,noreferrer');
		},
		downloadMedia() {
			const data = this.parseMediaContent();
			const url = this.getMediaUrl();
			if (!url) {
				this.$message.error('下载地址无效');
				return;
			}
			const link = document.createElement('a');
			link.href = url;
			link.download = this.sanitizeDownloadName(data.name || data.fileName || '');
			link.target = '_blank';
			link.rel = 'noopener noreferrer';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		showRightMenu(e) {
			if (this.selectionMode || !this.menu) {
				return;
			}
			const pos = { x: e.clientX, y: e.clientY };
			this.$refs.rightMenu.open(pos, this.menuItems);
		},
			onSelectMenu(item) {
				// 处理语音转文字
				if (item.key === 'SPEECH_TO_TEXT') {
					this.onSpeechToText();
				} else if (item.key === 'DOWNLOAD') {
					this.downloadMedia();
				} else if (item.key === 'MULTI_SELECT') {
					this.$emit('multi-select', this.msgInfo);
				} else {
					this.$emit(item.key.toLowerCase(), this.msgInfo);
				}
			},
			isReceiptMember(member) {
				if (!member || member.userId === this.msgInfo.sendId) {
					return false;
				}
				const sendTime = this.msgInfo.sendTime;
				if (member.createdTime && sendTime && member.createdTime > sendTime) {
					return false;
				}
				if (member.quit && member.quitTime && sendTime && member.quitTime < sendTime) {
					return false;
				}
				return !member.quit || !member.quitTime || !sendTime || member.quitTime >= sendTime;
			},
			onShowReadedBox() {
				if (!this.showGroupReceipt) {
					return;
				}
				let rect = this.$refs.chatMsgBox.getBoundingClientRect();
				this.$refs.chatGroupReadedBox.open(rect);
			},
		onSpeechToText() {
			// 显示加载提示
			const loadingInstance = this.$loading({
				lock: true,
				text: '正在转换...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});

			// 获取音频文件URL
			let audioUrl, msgId;
			try {
				const audioData = JSON.parse(this.msgInfo.content);
				audioUrl = audioData.url;
				msgId = this.msgInfo.id;
				console.log("语音转文字 - URL:", audioUrl);
				console.log("语音转文字 - 消息ID:", msgId);
			} catch (error) {
				loadingInstance.close();
				console.error('解析语音消息内容失败:', error);
				console.log('语音消息内容:', this.msgInfo.content);
				this.$message.error('语音消息格式错误');
				return;
			}

			// 调用语音转文字API
			this.convertSpeechToText(audioUrl).then((text) => {
				loadingInstance.close();
				console.log("语音转文字成功:", text);
				// 存储结果
				this.$set(this.speechTextMap, msgId, text);
				localStorage.setItem('speechText_' + msgId, text);
				this.$message.success('转换完成');
			}).catch((error) => {
				loadingInstance.close();
				console.error('语音转文字失败:', error);
				this.$message.error('转换失败，请重试');
			});
		},
		convertSpeechToText(audioUrl) {
			return new Promise((resolve, reject) => {
				console.log("开始调用语音转文字API，原始URL:", audioUrl);
				
				// 根据环境动态获取ASR API地址
				let asrApiUrl;
				if (process.env.NODE_ENV === 'development') {
					// 开发环境使用代理
					asrApiUrl = '/asr';
				} else {
					// 生产环境使用完整URL
					asrApiUrl = process.env.VUE_APP_BASE_API + '/asr';
				}
				
				console.log("ASR API地址:", asrApiUrl);
				
				fetch(asrApiUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					body: new URLSearchParams({
						file_url: audioUrl
					})
				})
				.then(response => response.json())
				.then(data => {
					console.log("语音转文字API响应:", data);
					if (data.code === 0) {
						console.log("语音转文字成功:", data.text);
						resolve(data.text);
					} else {
						console.error("语音转文字API返回错误:", data);
						reject(new Error(data.message || '转换失败'));
					}
				})
				.catch(error => {
					console.error("语音转文字API调用失败:", error);
					reject(error);
				});
			});
		},
		onOpenFriendCard(e) {
			try {
				const data = this.friendCardData;
				if (!data || !data.id) return;
				// 跳转到通讯录，并在右侧展示该用户详情
				this.$router.push('/home/contact');
				this.$nextTick(() => {
					this.$eventBus && this.$eventBus.$emit('openContactUser', data);
				});
			} catch (err) {
				console.error('打开好友名片失败', err, this.msgInfo);
			}
		},
			toReceiptNumber(value) {
				if (value === undefined || value === null || value === '') {
					return null;
				}
				const num = Number(value);
				return Number.isFinite(num) ? num : null;
			},
			onToggleSelect() {
				if (!this.canSelect) {
					return;
				}
				this.$emit('toggle-select', this.msgInfo);
			},
			onMessageClick() {
				if (this.selectionMode) {
					this.onToggleSelect();
				}
			}
		},
		computed: {
			canSelect() {
				return this.$msgType.isNormal(this.msgInfo.type) && this.msgInfo.id > 0;
			},
			avatarUserId() {
				const rawId = this.userId || (this.msgInfo && this.msgInfo.sendId);
				const numericId = Number(rawId);
				return Number.isNaN(numericId) ? rawId : numericId;
			},
			isGroupMessage() {
				return !!this.msgInfo.groupId;
			},
			isGroupChat() {
				return this.chatType === 'GROUP' || (!this.chatType && this.isGroupMessage);
			},
			isPrivateChat() {
				return !this.isGroupChat;
			},
			showSenderName() {
				return this.isGroupChat;
			},
			isTrackableGroupMessage() {
				return this.mine && this.isGroupChat && this.$msgType.isNormal(this.msgInfo.type);
			},
		showPrivateStatus() {
			return this.mine && !this.isGroupChat && !this.showLocalSendLoading && !this.showLocalSendFail;
			},
			groupUnreadCount() {
				if (!this.isTrackableGroupMessage) {
					return 0;
				}
				const unreadCount = this.toReceiptNumber(this.msgInfo.unreadCount);
				if (unreadCount !== null) {
					return Math.max(unreadCount, 0);
				}
				const receiptTotalValue = this.toReceiptNumber(this.msgInfo.receiptTotal);
				const receiptTotal = receiptTotalValue !== null
					? receiptTotalValue
					: (this.groupMembers || []).filter(member => this.isReceiptMember(member)).length;
				const readedCountValue = this.toReceiptNumber(this.msgInfo.readedCount);
				const readedCount = readedCountValue !== null ? readedCountValue : 0;
				return Math.max(receiptTotal - readedCount, 0);
			},
		showGroupReceipt() {
			return this.isTrackableGroupMessage && !this.showLocalSendLoading && !this.showLocalSendFail;
		},
		showLocalSendLoading() {
			return this.mine && this.msgInfo.type === this.$enums.MESSAGE_TYPE.TEXT &&
				this.msgInfo.clientMsgId && this.msgInfo.localSendStatus === 'retrying';
		},
		showLocalSendFail() {
			return this.mine && this.msgInfo.type === this.$enums.MESSAGE_TYPE.TEXT &&
				this.msgInfo.clientMsgId && this.msgInfo.localSendStatus === 'fail';
		},
			loading() {
				return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "loading";
			},
		loadFail() {
			return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "fail";
		},
		actionText() {
			// 用于 ACT_RT_VOICE / ACT_RT_VIDEO 等动作消息的展示文案
			let text = (this.msgInfo && this.msgInfo.content) ? this.msgInfo.content.trim() : '';
			if (text) return text;
			// 当 content 为空时，按类型给一个默认文字，避免只显示图标
			if (this.msgInfo.type === this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
				return '语音通话';
			}
			if (this.msgInfo.type === this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				return '视频通话';
			}
			return '';
		},
		data() {
			return JSON.parse(this.msgInfo.content)
		},
		fileSize() {
			let size = this.data.size;
			if (size > 1024 * 1024) {
				return Math.round(size / 1024 / 1024) + "M";
			}
			if (size > 1024) {
				return Math.round(size / 1024) + "KB";
			}
			return size + "B";
		},
		getFileExtension() {
			return getFileExtensionFromContent(this.data);
		},
			fileIconMeta() {
				return getFileIconMetaFromContent(this.data);
			},
			locationData() {
				if (!this.msgInfo || this.msgInfo.type != this.$enums.MESSAGE_TYPE.LOCATION || !this.msgInfo.content) {
					return null;
				}
				try {
					const rawData = typeof this.msgInfo.content === 'object'
						? this.msgInfo.content
						: JSON.parse(this.msgInfo.content);
					const latitude = Number(rawData.latitude);
					const longitude = Number(rawData.longitude);
					const validLatitude = Number.isFinite(latitude) && latitude >= -90 && latitude <= 90;
					const validLongitude = Number.isFinite(longitude) && longitude >= -180 && longitude <= 180;
					if (!validLatitude || !validLongitude || (latitude === 0 && longitude === 0)) {
						return null;
					}
					return {
						latitude,
						longitude,
						name: rawData.name || '我的位置',
						address: rawData.address || `纬度: ${latitude.toFixed(6)}, 经度: ${longitude.toFixed(6)}`
					};
				} catch (error) {
					console.error('解析位置消息失败:', error);
					return null;
				}
			},
			locationMapUrl() {
				const data = this.locationData;
				const mapUrl = process.env.VUE_APP_AMAP_STATIC_MAP_URL;
				const mapKey = process.env.VUE_APP_AMAP_KEY;
				if (!data || !mapUrl || !mapKey) {
					return '';
				}
				const params = new URLSearchParams({
					location: `${data.longitude},${data.latitude}`,
					zoom: '15',
					size: '320*170',
					scale: '2',
					key: mapKey,
					markers: `mid,,A:${data.longitude},${data.latitude}`
				});
				return `${mapUrl}?${params.toString()}`;
			},
			friendCardData() {
			try {
				if (this.msgInfo.type === this.$enums.MESSAGE_TYPE.FRIEND_CARD && this.msgInfo.content) {
					const data = JSON.parse(this.msgInfo.content);
					console.log('🃏 Web端解析好友名片数据:', data);
					return data;
				}
			} catch (e) {
				console.error('解析好友名片失败', e, this.msgInfo && this.msgInfo.content);
			}
			return null;
		},
		friendCardAvatar() {
			const data = this.friendCardData;
			if (!data) return '';
			// 名片里自带头像优先
			if (data.headImage) {
				console.log('🖼️ 使用名片自带头像:', data.headImage);
				return data.headImage;
			}
			if (data.headImageThumb) {
				console.log('🖼️ 使用名片缩略图:', data.headImageThumb);
				return data.headImageThumb;
			}
			// 再从好友列表兜底
			try {
				if (this.friendStore && this.friendStore.findFriend) {
					const f = this.friendStore.findFriend(data.id);
					if (f) {
						const avatar = f.headImageThumb || f.headImage || '';
						console.log('🖼️ 从好友列表获取头像:', avatar);
						return avatar;
					}
				}
			} catch (e) {
				console.error('从好友列表获取名片头像失败', e, data);
			}
			console.log('🖼️ 名片头像为空，将使用文字头像，data:', data);
			return '';
		},
		friendCardAvatarForDisplay() {
			return this.friendCardAvatar || '';
		},
		mergedForwardData() {
			if (!this.msgInfo || this.msgInfo.type != this.$enums.MESSAGE_TYPE.MERGED_FORWARD) {
				return null;
			}
			const data = this.parseMergedForwardContent();
			if (!data) {
				return null;
			}
			return {
				title: data.title || '聊天记录',
				summaryLines: Array.isArray(data.summaryLines) ? data.summaryLines : [],
				records: Array.isArray(data.records) ? data.records : []
			};
		},
		mergedForwardSummaryLines() {
			if (!this.mergedForwardData) {
				return [];
			}
			return this.mergedForwardData.summaryLines.slice(0, 4);
		},
		mergedForwardRecords() {
			if (!this.currentMergedForwardData) {
				return [];
			}
			return this.currentMergedForwardData.records;
		},
		currentMergedForwardData() {
			if (this.mergedForwardDetailStack.length) {
				return this.mergedForwardDetailStack[this.mergedForwardDetailStack.length - 1];
			}
			return this.mergedForwardData;
		},
		menuItems() {
			let items = [];
			// 语音转文字功能 - 放在第一个位置
			if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.AUDIO) {
				items.push({
					key: 'SPEECH_TO_TEXT',
					name: '语音转文字',
					icon: 'el-icon-microphone'
				});
			}
			// 引用功能 - 支持普通消息，且消息已落库(id>0)
			if (this.$msgType.isNormal(this.msgInfo.type) && this.msgInfo.id > 0) {
				items.push({
					key: 'QUOTE',
					name: '引用',
					icon: 'el-icon-quote'
				});
				items.push({
					key: 'FAVORITE',
					name: '收藏',
					icon: 'el-icon-star-off'
				});
				items.push({
					key: 'MULTI_SELECT',
					name: '多选',
					icon: 'el-icon-check'
				});
			}
			if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.TEXT) {
				items.push({
					key: 'COPY',
					name: '复制',
					icon: 'el-icon-document-copy'
				});
				items.push({
					key: 'FORWARD',
					name: '转发',
					icon: 'el-icon-share'
				});
			}
			items.push({
				key: 'DELETE',
				name: '删除',
				icon: 'el-icon-delete'
			});
			if (this.msgInfo.selfSend && this.msgInfo.id > 0) {
				items.push({
					key: 'RECALL',
					name: '撤回',
					icon: 'el-icon-refresh-left'
				});
			}
			// 如果不是文本消息，添加转发选项
			if (this.msgInfo.type != this.$enums.MESSAGE_TYPE.TEXT) {
				items.push({
					key: 'FORWARD',
					name: '转发',
					icon: 'el-icon-share'
				});
			}
			if (this.msgInfo.type == this.$enums.MESSAGE_TYPE.IMAGE || this.msgInfo.type == this.$enums.MESSAGE_TYPE.FILE) {
				items.push({
					key: 'DOWNLOAD',
					name: '下载',
					icon: 'el-icon-download'
				});
			}
			return items;
		},
		isAction() {
			return this.$msgType.isAction(this.msgInfo.type);
		},
		isNormal() {
			const type = this.msgInfo.type;
			return this.$msgType.isNormal(type) || this.$msgType.isAction(type)
		},
		htmlText() {
			let text = this.$url.replaceURLWithHTMLLinks(this.msgInfo.content, '')
			return this.$emo.transform(text, 'emoji-normal')
		}
	},
	beforeDestroy() {
		document.removeEventListener('pointerdown', this.onVoiceVolumeOutsidePointerDown);
		if (this.showMergedForwardDetail) {
			this.emitMergedForwardDetailVisible(false);
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-message-item {

	.message-tip {
		line-height: 32px;
		font-size: var(--im-font-size-small);
		color: var(--im-text-color-light);
		text-align: center;
		margin: 10px 0;
	}

	.message-normal {
		position: relative;
		font-size: 0;
		padding-left: 45px;  /* 减小左侧内边距 */
		padding-right: 16px;  /* 保持右侧内边距不变 */
		min-height: 50px;
		direction: ltr;
		margin-top: 10px;
		width: 100%;  /* 确保元素占满父容器宽度 */
		box-sizing: border-box;  /* 确保内边距不会导致元素宽度增加 */

		> .head-image {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0;  /* 更靠左一点，让左右头像留白更一致 */
			cursor: pointer;
		}

		.message-select-toggle {
			position: absolute;
			left: 6px;
			top: 10px;
			width: 18px;
			height: 18px;
			border: 2px solid #c5cad6;
			border-radius: 50%;
			background: #ffffff;
			box-sizing: border-box;
			cursor: pointer;
			z-index: 2;
		}

		.message-select-toggle.checked {
			border-color: #2f7cf6;
			background: #2f7cf6;
		}

		.message-select-toggle.checked::after {
			content: "";
			position: absolute;
			left: 5px;
			top: 2px;
			width: 4px;
			height: 8px;
			border: solid #ffffff;
			border-width: 0 2px 2px 0;
			transform: rotate(45deg);
		}

		&.message-selecting {
			padding-left: 78px;
			cursor: pointer;
		}

		&.message-selecting > .head-image {
			left: 33px;
		}

		.content {
			text-align: left;

			.local-send-state {
				align-self: center;
				flex: 0 0 auto;
				margin-right: 8px;
				font-size: 20px;
				line-height: 1;
			}

			.local-send-loading {
				color: var(--im-text-color-light);
			}

			.local-send-fail {
				color: var(--im-color-danger);
				cursor: pointer;
			}

			.send-fail {
				color: #e60c0c;
				font-size: 30px;
				cursor: pointer;
				margin: 0 20px;
			}

			.message-top {
				display: flex;
				flex-wrap: nowrap;
				position: relative;
				top: -4px;
				color: var(--im-text-color-light);
				font-size: var(--im-font-size);
				line-height: 20px;
				margin-top: 0;
				margin-bottom: 2px;

				span {
					margin-right: 12px;
				}
			}

			.message-bottom {
				display: block;  /* 改为block以占满父容器宽度 */
				width: 100%;  /* 确保占满父容器宽度 */
				box-sizing: border-box;  /* 确保内边距不会导致元素宽度增加 */
				padding-right: 16px;
				padding-left: 0;

					.message-quote {
						display: flex;
						width: 280px;
						margin-top: 4px;
						font-size: var(--im-font-size-smaller);
						color: var(--im-text-color-light);
						box-sizing: border-box;

						.quote-content {
							display: flex;
							align-items: center;
							width: 100%;
							min-width: 0;
							background: #f5f5f5;
							border-radius: 6px;
							padding: 4px 8px;
							box-sizing: border-box;
						}

					.quote-content-rich {
						gap: 8px;
						padding: 6px 8px;
					}

					.quote-content-stacked {
						flex-direction: column;
						align-items: flex-start;
						gap: 2px;
					}

					.quote-content-stacked .quote-heading {
						max-width: 100%;
						margin-right: 0;
					}

					.quote-name {
						font-weight: 600;
						margin-right: 4px;
					}

					.quote-heading {
						display: inline-flex;
						align-items: center;
						flex: 0 1 auto;
						min-width: 0;
						margin-right: 6px;
					}

					.quote-type-label {
						flex: 0 0 auto;
						font-weight: 400;
						color: var(--im-text-color-light);
						white-space: nowrap;
					}

					.quote-text {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

						.quote-rich-main {
							flex: 1;
							min-width: 0;
						}

					.quote-rich-line {
						display: flex;
						align-items: center;
						min-width: 0;
					}

					.quote-flow-copy {
						display: block;
						width: 100%;
						max-height: 36px;
						line-height: 18px;
						overflow: hidden;
						white-space: normal;
						word-break: break-all;
					}

					.quote-flow-prefix {
						display: inline-flex;
						align-items: center;
						max-width: 150px;
						vertical-align: bottom;
						white-space: nowrap;
					}

					.quote-flow-body {
						color: var(--im-text-color-light);
					}

					.quote-rich-icon {
						flex: 0 0 auto;
						margin-right: 4px;
						color: var(--im-text-color-light);
					}

					.quote-rich-text {
						min-width: 0;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.quote-card-brief {
						display: inline-flex;
						align-items: center;
						min-width: 0;
						max-width: 130px;
						color: var(--im-text-color-light);
					}

					.quote-card-type-icon {
						flex: 0 0 auto;
						margin-right: 4px;
						font-size: 14px;
						color: var(--im-text-color-light);
					}

					.quote-card-name {
						min-width: 0;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.quote-rich-thumb {
						flex: 0 0 auto;
						width: 42px;
						height: 42px;
						object-fit: cover;
						border-radius: 4px;
						background: #d1d5db;
					}

					.quote-card-placeholder,
					.quote-file-placeholder {
						display: inline-flex;
						align-items: center;
						justify-content: center;
						color: #fff;
						font-size: 22px;
					}

					.quote-file-placeholder {
						color: #6b7280;
					}

					.quote-inline-file-icon,
					.quote-file-icon {
						position: relative;
						flex: 0 0 auto;
						display: inline-flex;
						align-items: center;
						justify-content: center;

						.file-icon-paper {
							position: relative;
							display: block;
							border-radius: 3px;
							background-color: #d42e07;
							box-shadow: 0 1px 4px rgba(15, 23, 42, 0.16);
							overflow: hidden;
						}

						.file-icon-fold {
							position: absolute;
							right: 0;
							top: 0;
							background: rgba(255, 255, 255, 0.82);
							clip-path: polygon(0 0, 100% 0, 100% 100%);
						}

						.file-icon-fold::after {
							content: "";
							position: absolute;
							left: 0;
							bottom: 0;
							height: 1px;
							background: rgba(0, 0, 0, 0.10);
							transform: rotate(45deg);
							transform-origin: left bottom;
						}

						.file-icon-mark {
							position: absolute;
							left: 0;
							right: 0;
							color: #ffffff;
							font-weight: 800;
							text-align: center;
							text-transform: uppercase;
							letter-spacing: 0;
						}

						&.file-icon-audio .file-icon-paper { background-color: #8b5cf6; }
						&.file-icon-video .file-icon-paper { background-color: #ef4444; }
						&.file-icon-word .file-icon-paper { background-color: #2b6fdb; }
						&.file-icon-excel .file-icon-paper { background-color: #1f9d55; }
						&.file-icon-ppt .file-icon-paper { background-color: #f0642f; }
						&.file-icon-pdf .file-icon-paper { background-color: #d42e07; }
						&.file-icon-image .file-icon-paper { background-color: #0ea5e9; }
						&.file-icon-archive .file-icon-paper { background-color: #a16207; }
						&.file-icon-code .file-icon-paper { background-color: #475569; }
						&.file-icon-default .file-icon-paper { background-color: #d42e07; }
					}

					.quote-inline-file-icon {
						width: 18px;
						height: 22px;
						margin-right: 4px;

						.file-icon-paper {
							width: 15px;
							height: 18px;
						}

						.file-icon-fold {
							width: 6px;
							height: 6px;
						}

						.file-icon-fold::after {
							width: 7px;
						}

						.file-icon-mark {
							bottom: 2px;
							font-size: 9px;
							line-height: 10px;
						}

						&.file-icon-pdf .file-icon-mark,
						&.file-icon-image .file-icon-mark,
						&.file-icon-archive .file-icon-mark,
						&.file-icon-code .file-icon-mark,
						&.file-icon-default .file-icon-mark {
							font-size: 6px;
							line-height: 8px;
						}
					}

					.quote-file-icon {
						width: 32px;
						height: 38px;

						.file-icon-paper {
							width: 26px;
							height: 32px;
						}

						.file-icon-fold {
							width: 9px;
							height: 9px;
						}

						.file-icon-fold::after {
							width: 10px;
						}

						.file-icon-mark {
							bottom: 5px;
							font-size: 16px;
							line-height: 17px;
						}

						&.file-icon-pdf .file-icon-mark,
						&.file-icon-image .file-icon-mark,
						&.file-icon-archive .file-icon-mark,
						&.file-icon-code .file-icon-mark,
						&.file-icon-default .file-icon-mark {
							font-size: 9px;
							line-height: 11px;
						}
					}

					.quote-card-initial {
						color: #fff;
						font-size: 16px;
						font-weight: 500;
						line-height: 1;
					}
				}

				.message-text {
					display: inline-block;
					position: relative;
					line-height: 26px;
					margin-left: 4px;   /* 再往左收一点 */
					padding: 6px 14px; /* 稍微细长一点，接近示例图 */
					background-color: var(--im-background);
					border-radius: 4px 12px 12px 12px; /* 左侧尖角稍微柔和一点，其他三角圆角与自己气泡一致 */
					box-shadow: 0 3px 8px rgba(15, 23, 42, 0.08); /* 再柔一点的阴影 */
					font-size: var(--im-font-size);
					text-align: left;
					white-space: pre-wrap;
					word-break: break-all;
				}

				.message-image {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;

					.send-image {
						min-width: 200px;
						min-height: 150px;
						max-width: 400px;
						max-height: 300px;
						border-radius: 8px;
						cursor: pointer;
					}

				}

				.message-file {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-bottom: 2px;

					.chat-file-box {
						display: flex;
						flex-wrap: nowrap;
						align-items: center;
						width: 280px;
						min-height: 60px;
						background: #ffffff;
						border-radius: 8px;
						box-shadow: 0 3px 8px rgba(15, 23, 42, 0.08);
						padding: 10px 15px;
						box-sizing: border-box;

						.chat-file-info {
							flex: 1;
							height: 100%;
							text-align: left;
							font-size: 14px;
							margin-right: 10px;

							.chat-file-name {
								display: inline-block;
								min-width: 160px;
								max-width: 220px;
								font-size: 14px;
								margin-bottom: 4px;
								white-space: pre-wrap;
								word-break: break-all;
							}

							.chat-file-size {
								font-size: var(--im-font-size-smaller);
								color: var(--im-text-color-light);
							}
						}

						.chat-file-icon {
							position: relative;
							width: 42px;
							height: 50px;
							margin-left: 8px;
							flex: 0 0 42px;
							display: flex;
							align-items: center;
							justify-content: center;

							.file-icon-paper {
								position: absolute;
								right: 0;
								top: 2px;
								width: 34px;
								height: 42px;
								border-radius: 3px;
								background-color: #d42e07;
								box-shadow: 0 2px 6px rgba(15, 23, 42, 0.16);
								overflow: hidden;
							}

							.file-icon-fold {
								position: absolute;
								right: 0;
								top: 0;
								width: 12px;
								height: 12px;
								background: rgba(255, 255, 255, 0.82);
								clip-path: polygon(0 0, 100% 0, 100% 100%);
							}

							.file-icon-fold::after {
								content: "";
								position: absolute;
								left: 0;
								bottom: 0;
								width: 14px;
								height: 1px;
								background: rgba(0, 0, 0, 0.10);
								transform: rotate(45deg);
								transform-origin: left bottom;
							}

							.file-icon-mark {
								position: absolute;
								left: 0;
								right: 0;
								bottom: 6px;
								color: #ffffff;
								font-size: 20px;
								line-height: 22px;
								font-weight: 800;
								text-align: center;
								text-transform: uppercase;
								letter-spacing: 0;
							}

							&.file-icon-audio .file-icon-paper {
								background-color: #8b5cf6;
							}

							&.file-icon-video .file-icon-paper {
								background-color: #ef4444;
							}

							&.file-icon-word .file-icon-paper {
								background-color: #2b6fdb;
							}

							&.file-icon-excel .file-icon-paper {
								background-color: #1f9d55;
							}

							&.file-icon-ppt .file-icon-paper {
								background-color: #f0642f;
							}

							&.file-icon-pdf .file-icon-paper {
								background-color: #d42e07;
							}

							&.file-icon-image .file-icon-paper {
								background-color: #0ea5e9;
							}

							&.file-icon-archive .file-icon-paper {
								background-color: #a16207;
							}

							&.file-icon-code .file-icon-paper {
								background-color: #475569;
							}

							&.file-icon-default .file-icon-paper {
								background-color: #d42e07;
							}

							&.file-icon-pdf .file-icon-mark,
							&.file-icon-image .file-icon-mark,
							&.file-icon-archive .file-icon-mark,
							&.file-icon-code .file-icon-mark,
							&.file-icon-default .file-icon-mark {
								font-size: 11px;
								line-height: 14px;
								bottom: 8px;
							}
						}
					}

					.send-fail {
						color: #e60c0c;
						font-size: 30px;
						cursor: pointer;
						margin: 0 20px;
					}

				}

					.message-location {
						display: inline-flex;
						flex-direction: column;
						align-items: stretch;
						width: 280px;
						background: #ffffff;
						border: 1px solid #e9ebef;
						border-radius: 8px;
						box-shadow: 0 3px 8px rgba(15, 23, 42, 0.08);
						overflow: hidden;
						box-sizing: border-box;
						text-align: left;
						cursor: pointer;

						.location-map-preview {
							width: 100%;
							height: 170px;
							background: #eef1f5;
							overflow: hidden;
						}

						.location-map-image {
							display: block;
							width: 100%;
							height: 100%;
							object-fit: cover;
						}

						.location-map-placeholder {
							display: flex;
							flex-direction: column;
							align-items: center;
							justify-content: center;
							height: 100%;
							gap: 8px;
							color: #8a8f99;
							font-size: 13px;

							i {
								font-size: 30px;
								color: #ef5350;
							}
						}

						.location-info {
							padding: 9px 14px 8px;
							background: #ffffff;
						}

						.location-name {
							font-size: 16px;
							line-height: 21px;
							font-weight: 600;
							color: #202124;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						.location-address {
							margin-top: 3px;
							font-size: 13px;
							line-height: 18px;
							color: #777777;
							word-break: break-word;
						}
					}

				.message-status {
					display: block;
					margin-top: 4px;
					text-align: right;
					font-size: 12px !important;
					line-height: 16px !important;

					.chat-readed {
						font-size: 12px !important;
						color: var(--im-text-color-light);
					}

					.chat-unread {
						font-size: 12px !important;
						color: var(--im-color-danger);
					}
				}

				.chat-receipt {
					display: inline-flex;
					align-self: flex-end;
					justify-content: flex-end;
					margin-top: 4px;
					min-height: 16px;
					font-size: 12px;
					line-height: 16px;
					cursor: pointer;
					color: #1677ff;

					.chat-receipt-text {
						font-size: 12px;
						line-height: 16px;
						font-weight: 500;
						color: #1677ff;
						white-space: nowrap;
					}

					.icon-ok {
						font-size: 20px;
						color: var(--im-color-sucess);
					}
				}

				.chat-at-user {
					padding: 2px 5px;
					border-radius: 3px;
					cursor: pointer;
				}

				// 名片卡片样式
    				.message-card {
    					display: inline-flex;
					flex-direction: column;
					align-items: stretch;
					width: 280px;
					background: #ffffff;
					border-radius: 8px;
					padding: 14px 14px 9px;
					box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04);
					box-sizing: border-box;
					cursor: pointer;
					margin-top: 2px;
					border: 1px solid #eeeeee;
					background-clip: padding-box;

					.card-main {
						display: flex;
						align-items: center;
						min-height: 42px;
					}
			
					.card-avatar {
						flex-shrink: 0;
						order: 0;
						margin: 0 12px 0 0;
						line-height: 0;
						width: 42px;
						height: 42px;
					}
			
					.card-name {
						flex: 1;
						font-size: 17px;
						color: #1f2329;
						font-weight: 500;
						line-height: 1.35;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
						text-align: left;
					}

					.card-divider {
						height: 1px;
						margin: 12px 0 6px;
						background-color: #eeeeee;
					}
			
					.card-tip {
						font-size: 12px;
						line-height: 1.3;
						color: #8a8f99;
						text-align: left;
    					}
    				}

					.message-merged-forward {
						display: inline-flex;
						flex-direction: column;
						align-items: stretch;
						width: 280px;
						padding: 14px 16px 10px;
						background: #ffffff;
						border-radius: 8px;
						box-shadow: 0 3px 8px rgba(15, 23, 42, 0.08);
						box-sizing: border-box;
						text-align: left;
						cursor: pointer;
					}

					.merged-forward-title {
						font-size: 16px;
						line-height: 24px;
						font-weight: 700;
						color: #202124;
						margin-bottom: 8px;
					}

					.merged-forward-lines {
						display: flex;
						flex-direction: column;
						gap: 4px;
					}

					.merged-forward-line {
						font-size: 13px;
						line-height: 20px;
						color: #777777;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.merged-forward-divider {
						height: 1px;
						margin: 10px 0 7px;
						background: #eeeeee;
					}

					.merged-forward-tip {
						font-size: 12px;
						line-height: 18px;
						color: #999999;
					}
    			}

			// 语音消息是 .content 的直接子元素，固定与名片卡片相同宽度。
			.message-voice {
				display: flex;
				flex-direction: column;
				align-items: stretch;
				width: 280px;
				max-width: 100%;
				box-sizing: border-box;
				font-size: 14px;
				cursor: pointer;

				.voice-player {
					position: relative;
					width: 100%;
					height: 45px;
				}

				audio {
					display: block;
					width: 100%;
					height: 45px;
					padding: 5px 0;
					box-sizing: border-box;
				}

				audio::-webkit-media-controls-mute-button,
				audio::-webkit-media-controls-volume-slider {
					display: none;
				}

				.voice-volume-control {
					position: absolute;
					right: 31px;
					top: 50%;
					z-index: 3;
					width: 32px;
					height: 32px;
					transform: translateY(-50%);
				}

				.voice-volume-button {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 32px;
					height: 32px;
					padding: 0;
					border: 0;
					border-radius: 50%;
					background: transparent;
					color: #202124;
					cursor: pointer;
				}

				.voice-volume-button:hover,
				.voice-volume-button:focus-visible {
					background: rgba(60, 64, 67, 0.10);
					outline: none;
				}

				.voice-volume-icon {
					width: 19px;
					height: 19px;
				}

				.voice-volume-speaker {
					fill: currentColor;
				}

				.voice-volume-wave {
					fill: none;
					stroke: currentColor;
					stroke-width: 1.8;
					stroke-linecap: round;
				}

				.voice-volume-panel {
					position: absolute;
					left: 50%;
					bottom: calc(100% + 7px);
					width: 38px;
					height: 108px;
					transform: translateX(-50%);
					border: 1px solid rgba(15, 23, 42, 0.08);
					border-radius: 19px;
					background: #f1f3f4;
					box-shadow: 0 5px 14px rgba(15, 23, 42, 0.18);
				}

				.voice-volume-slider {
					position: absolute;
					left: 50%;
					top: 50%;
					width: 82px;
					height: 4px;
					margin: 0;
					transform: translate(-50%, -50%) rotate(-90deg);
					accent-color: #5f6368;
					cursor: pointer;
				}
			}

			// 通话消息样式（.chat-action 是 .content 的直接子元素）
			.chat-action {
				display: inline-flex !important;
				align-items: center;
				line-height: 26px;
				padding: 6px 14px;
				background-color: var(--im-background) !important; /* 与对方普通消息气泡一致 */
				border-radius: 4px 12px 12px 12px; /* 与对方消息相同的圆角形状，尖角稍微柔和一点 */
				box-shadow: 0 3px 8px rgba(15, 23, 42, 0.08);
				text-align: left;
				font-size: var(--im-font-size) !important;

				.chat-icon {
					cursor: pointer;
					font-size: 22px !important;
					padding-right: 8px;
				}
			}
		}


		&.message-private {
			.content {
				.message-bottom { margin-top: 0; }
				.message-status { display: block; margin-top: 2px; text-align: right; font-size: 12px !important; line-height: 16px !important; }
				.message-status .chat-readed { font-size: 12px !important; color: var(--im-text-color-light); }
				.message-status .chat-unread { font-size: 12px !important; color: var(--im-color-danger); }
			}
		}

    		&.message-mine {
			direction: rtl;
			text-align: right;
			padding-left: 0;
			padding-right: 48px;
			direction: ltr;

    			> .head-image {
    				left: auto;
    				right: 0;
    			}

				.message-select-toggle {
					left: 10px;
				}

			.content {
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				text-align: right;

				.message-top {
					width: auto;
					align-self: flex-end;
					justify-content: flex-end;
					flex-direction: row-reverse;
					column-gap: 12px;
					top: -4px;
					margin-right: 0;

					span {
						margin-right: 0;
						margin-left: 0;
					}
				}
				
				// 自己发送的通话消息气泡样式
				.chat-action {
					/* 这里的具体颜色和圆角，会在下面统一覆盖为与自己文本消息一致 */
				}
				
				.message-bottom {
					padding-left: 180px;
					padding-right: 0;
					margin-top: -2px;
					text-align: right;

					> div {
						display: flex;
						justify-content: flex-end;
					}

					.message-text {
						margin-left: 0;
						margin-top: 0;
						background-color: #d4def5; /* 比导航色稍深一点的主色蓝 */
						color: #111827; /* 深色文字，提升可读性 */
						border-radius: 12px 4px 12px 12px; /* 自己发送的消息尖角稍微柔和一点，圆角略小以贴近 App */
						box-shadow: 0 6px 14px rgba(15, 23, 42, 0.10);
					}

					/* 自己发送的消息下方的引用条：与气泡右对齐 */
						.message-quote {
							justify-content: flex-end;
							margin-left: auto;

							.quote-content {
								margin-left: 10px;
						}
					}

					.message-image {
						flex-direction: row-reverse;
					}

					.message-file {
						flex-direction: row-reverse;
					}
				}

				/* 发送方的通话气泡样式覆盖 */
				.chat-action {
					flex-direction: row; /* 保持图标在左，文字在右 */
					background-color: #d4def5 !important; /* 与自己文本消息气泡一致的浅蓝色 */
					color: #111827 !important;
					border-radius: 12px 4px 12px 12px !important; /* 与自己文本消息气泡相同的圆角，尖角稍微柔和一点 */
					box-shadow: 0 6px 14px rgba(15, 23, 42, 0.10);
					
					.chat-icon {
						font-size: 18px !important;
						padding-right: 8px; /* 图标右侧间距 */
						padding-left: 0;
						color: #111827 !important;
					}
				}
				}
			}

			&.message-private.message-mine {
				.content {
					.message-bottom { margin-top: 0; }
				}
			}

		}
    }
    </style>
    
    <style scoped>
    .merged-forward-detail-mask {
    	position: fixed;
    	left: 0;
    	top: 0;
    	right: 0;
    	bottom: 0;
    	z-index: 10000;
    	display: flex;
    	align-items: center;
    	justify-content: center;
    	background: rgba(0, 0, 0, 0.35);
    }

    .merged-forward-detail-panel {
    	width: 560px;
    	max-width: calc(100vw - 48px);
    	height: 680px;
    	max-height: calc(100vh - 80px);
    	background: #f4f5f8;
    	border-radius: 12px;
    	overflow: hidden;
    	box-sizing: border-box;
    	box-shadow: 0 18px 48px rgba(15, 23, 42, 0.22);
    }

    .merged-forward-detail-header {
    	display: flex;
    	align-items: center;
    	justify-content: space-between;
    	height: 56px;
    	padding: 0 18px;
    	background: #ffffff;
    	border-bottom: 1px solid #e6e8ee;
    	box-sizing: border-box;
    }

    .merged-forward-detail-title {
    	font-size: 18px;
    	font-weight: 700;
    	color: #1f2933;
    	overflow: hidden;
    	text-overflow: ellipsis;
    	white-space: nowrap;
    }

    .merged-forward-detail-close {
    	color: #999999;
    	cursor: pointer;
    }

    .merged-forward-detail-body {
    	height: calc(100% - 56px);
    	padding: 18px 22px 32px;
    	box-sizing: border-box;
    	overflow-y: auto;
    }

    .merged-forward-record {
    	padding: 0 0 18px;
    	margin-bottom: 18px;
    	border-bottom: 1px solid #e6e8ee;
    	text-align: left;
    }

    .merged-forward-record-meta {
    	display: flex;
    	align-items: center;
    	justify-content: space-between;
    	margin-bottom: 7px;
    }

    .merged-forward-record-name {
    	font-size: 13px;
    	line-height: 18px;
    	color: #777777;
    }

    .merged-forward-record-time {
    	margin-left: 10px;
    	font-size: 12px;
    	line-height: 18px;
    	color: #a0a4aa;
    	white-space: nowrap;
    }

    .merged-forward-record-bubble {
    	display: inline-block;
    	max-width: 86%;
    	padding: 10px 13px;
    	background: #ffffff;
    	border-radius: 10px;
    	font-size: 15px;
    	line-height: 22px;
    	color: #202124;
    	word-break: break-word;
    	white-space: pre-wrap;
    }

    .merged-forward-record-image {
    	display: block;
    	max-width: 180px;
    	max-height: 180px;
    	border-radius: 8px;
    	object-fit: cover;
    	background: #eef0f3;
    }

    .merged-forward-record-file,
    .merged-forward-record-card {
    	display: flex;
    	align-items: center;
    	width: 280px;
    	padding: 12px 14px;
    	background: #ffffff;
    	border-radius: 4px;
    	box-sizing: border-box;
    	cursor: pointer;
    }

    .merged-forward-record-file-info {
    	flex: 1;
    	min-width: 0;
    	margin-right: 12px;
    }

    .merged-forward-record-file-name {
    	font-size: 15px;
    	line-height: 22px;
    	font-weight: 600;
    	color: #202124;
    	word-break: break-word;
    }

    .merged-forward-record-file-size {
    	margin-top: 6px;
    	font-size: 13px;
    	line-height: 18px;
    	color: #8a8f99;
    }

    .merged-forward-record-file-icon {
    	position: relative;
    	width: 42px;
    	height: 50px;
    	flex: 0 0 42px;
    }

    .merged-forward-record-file-icon .file-icon-paper {
    	position: absolute;
    	right: 0;
    	top: 2px;
    	width: 34px;
    	height: 42px;
    	border-radius: 3px;
    	background-color: #d42e07;
    	box-shadow: 0 2px 6px rgba(15, 23, 42, 0.16);
    	overflow: hidden;
    }

    .merged-forward-record-file-icon .file-icon-fold {
    	position: absolute;
    	right: 0;
    	top: 0;
    	width: 12px;
    	height: 12px;
    	background: rgba(255, 255, 255, 0.82);
    	clip-path: polygon(0 0, 100% 0, 100% 100%);
    }

    .merged-forward-record-file-icon .file-icon-mark {
    	position: absolute;
    	left: 0;
    	right: 0;
    	bottom: 6px;
    	color: #ffffff;
    	font-size: 20px;
    	line-height: 22px;
    	font-weight: 800;
    	text-align: center;
    	text-transform: uppercase;
    }

    .merged-forward-record-file-icon.file-icon-excel .file-icon-paper {
    	background-color: #1f9d55;
    }

    .merged-forward-record-file-icon.file-icon-ppt .file-icon-paper {
    	background-color: #f0642f;
    }

    .merged-forward-record-file-icon.file-icon-word .file-icon-paper {
    	background-color: #2b6fdb;
    }

    .merged-forward-record-card {
    	display: block;
    }

    .merged-forward-record-card-title {
    	font-size: 16px;
    	line-height: 22px;
    	font-weight: 700;
    	color: #202124;
    	overflow: hidden;
    	text-overflow: ellipsis;
    	white-space: nowrap;
    }

    .merged-forward-record-card-lines {
    	margin-top: 8px;
    }

    .merged-forward-record-card-line {
    	font-size: 13px;
    	line-height: 20px;
    	color: #777777;
    	overflow: hidden;
    	text-overflow: ellipsis;
    	white-space: nowrap;
    }

    .merged-forward-record-card-divider {
    	height: 1px;
    	margin: 10px 0 8px;
    	background: #eeeeee;
    }

    .merged-forward-record-card-tip {
    	font-size: 13px;
    	line-height: 18px;
    	color: #999999;
    }

    .speech-text-result {
	width: 100%;
	box-sizing: border-box;
     	color: #666;
	font-size: 14px;
	margin-top: 8px;
	background: #f7f7f7;
	border-radius: 8px;
	padding: 8px 12px;
	word-break: break-all;
	white-space: pre-line;
	line-height: 1.6;
	text-align: left;
}
</style>
